export const QueryKey = {
	me: 'auth/me',
	attachments: 'attachments',
	userNotifications: 'user-notifications',
	companies: 'companies',
	complaints: 'complaints',
	clients: 'clients',
	contents: 'contents',
	files: 'files',
	contacts: 'contacts',
	components: 'components',

	attributes: 'attributes',
	attributeValues: 'attribute-values',

	shippingMethods: 'shipping-methods',
	shippingPriorities: 'shipping-priorities',

	orders: 'orders',
	orderItems: 'order-items',
	offers: 'offers',
	offerItems: 'offer-items',
	products: 'products',
	productTypes: 'product-types',
	productTypeCategories: 'product-type-categories',

	addresses: 'addresses',
} as const;

export type QueryKey = (typeof QueryKey)[keyof typeof QueryKey];
